<ng-container *ngIf="ganttData | async as ganttDataSource">
  <ejs-gantt
    #gantt
    class="header-size"
    [class.header-size-64]="false"
    [dataSource]="ganttDataSource"
    [taskFields]="taskSettings"
    [eventMarkers]="eventMarkers"
    [columns]="ganttColumns"
    [taskMode]="'Manual'"
    [splitterSettings]="{ columnIndex: 1 }"
    [toolbar]="toolbar"
    [timelineSettings]="timelineSettings"
    [loadChildOnDemand]="false"
    allowPdfExport="true"
    [allowResizing]="true"
    allowExcelExport="true"
    (toolbarClick)="ganttToolbarClick($event)"
    (queryTaskbarInfo)="queryTaskbarInfo($event)"
    (recordDoubleClick)="recordDoubleClick($event)"
    (rowSelected)="rowSelected($event)"
    [highlightWeekends]="true"
  >
  </ejs-gantt>
</ng-container>
